const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

const ID_DEFS = [
  { system: 'google', id_type: 'gclid', key: 'gclid' },
  { system: 'google', id_type: 'gbraid', key: 'gbraid' },
  { system: 'google', id_type: 'wbraid', key: 'wbraid' },
  { system: 'meta', id_type: 'fbclid', key: 'fbclid' },
  { system: 'tiktok', id_type: 'ttclid', key: 'ttclid' },
  { system: 'snap', id_type: 'sccid', key: 'ScCid' },
  { system: 'ms', id_type: 'msclkid', key: 'msclkid' },
]

const CLICK_ID_KEYS = ID_DEFS.map(function (entry) {
  return entry.key
})

const TOUCHES_LS_KEY = 'el_touches'

function hostFromReferrer(referrer) {
  const value = String(referrer || '').trim()
  if (!value || value === 'direct') return ''
  try {
    const withScheme = value.indexOf('://') === -1 ? 'https://' + value : value
    return new URL(withScheme).hostname
  } catch (e) {
    return value.replace(/^https?:\/\//, '').split('/')[0].split('?')[0]
  }
}

function pathFromLanding(landing) {
  const value = String(landing || '').trim()
  if (!value) return ''
  if (value.charAt(0) === '/') return value.split('?')[0].split('#')[0]
  try {
    return new URL(value).pathname || '/'
  } catch (e) {
    return ''
  }
}

function parseFbc(fbc) {
  const match = /^fb\.1\.(\d{10,})\.([A-Za-z0-9_-]{10,500})$/.exec(String(fbc || ''))
  if (!match) return null
  return { ms: match[1], fbclid: match[2] }
}

function isoFromMs(ms) {
  const n = Number(ms)
  if (!n || !isFinite(n)) return ''
  const date = new Date(n)
  if (isNaN(date.getTime())) return ''
  return date.toISOString()
}

function fieldValue(fields, key) {
  if (key === 'ScCid') return fields.ScCid || fields.sccid || ''
  return fields[key] || ''
}

function clickFieldName(idType) {
  if (idType === 'sccid') return 'ScCid'
  return idType || ''
}

function matchingFbc(fbc, fbclid) {
  const parsed = parseFbc(fbc)
  if (!parsed || parsed.fbclid !== fbclid) return ''
  return String(fbc)
}

function copyUtms(target, source) {
  Object.keys(source || {}).forEach(function (key) {
    if (key.indexOf('utm_') !== 0 || !source[key]) return
    target[key] = String(source[key])
  })
}

function isStoredTouch(item) {
  if (!item || !item.system || !item.ts || !item.ts_kind) return false
  if (item.system === 'utm_only') return true
  return Boolean(item.click_id && item.id_type)
}

function buildTouches(fields) {
  fields = fields || {}
  const touches = []
  const referrerHost = hostFromReferrer(fields.referrer)
  const landingPath = pathFromLanding(fields.landing_page || fields.landing_path)
  const visitTs = fields.timestamp || fields.ts || ''
  const parsedFbc = parseFbc(fields.fbc)
  const present = ID_DEFS.filter(function (entry) {
    return fieldValue(fields, entry.key)
  })

  function add(system, idType, clickId, ts, tsKind) {
    if (!clickId) return
    const touch = {
      system: system,
      id_type: idType || '',
      click_id: String(clickId),
      referrer_host: referrerHost,
      landing_path: landingPath,
      ts: ts || '',
      ts_kind: tsKind === 'click' ? 'click' : 'visit',
    }
    copyUtms(touch, fields)
    touches.push(touch)
  }

  ID_DEFS.forEach(function (entry) {
    let value = String(fieldValue(fields, entry.key) || '')
    if (entry.system === 'meta') {
      if (parsedFbc && parsedFbc.fbclid) value = parsedFbc.fbclid
      if (!value) return
      const clickTs = parsedFbc && parsedFbc.fbclid === value ? isoFromMs(parsedFbc.ms) : ''
      if (clickTs) {
        add('meta', 'fbclid', value, clickTs, 'click')
        return
      }
      const kind = present.length === 1 && fields.ts_kind === 'click' ? 'click' : 'visit'
      add('meta', 'fbclid', value, visitTs, kind)
      return
    }
    if (!value) return
    const ownTs = fields['ts_' + entry.key] || ''
    const ownKind = fields['kind_' + entry.key]
    let kind = 'visit'
    if (ownKind === 'click' || (!ownTs && present.length === 1 && fields.ts_kind === 'click')) kind = 'click'
    add(entry.system, entry.id_type, value, ownTs || visitTs, kind)
  })

  if (!touches.length && UTM_KEYS.some(function (key) { return fields[key] })) {
    const touch = {
      system: 'utm_only',
      id_type: '',
      click_id: '',
      referrer_host: referrerHost,
      landing_path: landingPath,
      ts: visitTs,
      ts_kind: 'visit',
    }
    copyUtms(touch, fields)
    touches.push(touch)
  }

  return touches
}

function touchKey(touch) {
  if (touch.system === 'utm_only') {
    return [
      'utm_only',
      touch.landing_path || '',
      touch.ts || '',
      touch.utm_source || '',
      touch.utm_campaign || '',
    ].join('\0')
  }
  return (touch.system || '') + '\0' + (touch.click_id || '')
}

function readVisitEvents() {
  if (typeof window === 'undefined') return []
  try {
    const list = JSON.parse(localStorage.getItem(TOUCHES_LS_KEY) || '[]')
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}

function expandTouch(item) {
  if (isStoredTouch(item)) return [item]
  return buildTouches(item)
}

function collectFormTouches(fields, events) {
  const list = Array.isArray(events) ? events : readVisitEvents()
  const touches = []
  const seen = {}

  function take(touch) {
    if (!touch || !touch.system || !touch.ts) return
    const key = touchKey(touch)
    if (seen[key]) return
    seen[key] = true
    touches.push(touch)
  }

  list.forEach(function (event) {
    expandTouch(event).forEach(take)
  })
  expandTouch(fields).forEach(take)
  return touches
}

function pickLastAdClick(touches) {
  let winner = null
  let winnerAt = -1
  ;(touches || []).forEach(function (touch, index) {
    if (!touch || !touch.click_id || !touch.ts) return
    if (!winner || touch.ts > winner.ts || (touch.ts === winner.ts && index > winnerAt)) {
      winner = touch
      winnerAt = index
    }
  })
  return winner
}

function latestUtmTouch(touches) {
  let winner = null
  let winnerAt = -1
  ;(touches || []).forEach(function (touch, index) {
    if (!touch || touch.system !== 'utm_only' || !touch.ts) return
    if (!winner || touch.ts > winner.ts || (touch.ts === winner.ts && index > winnerAt)) {
      winner = touch
      winnerAt = index
    }
  })
  return winner
}

function leadSourceFields(touches) {
  const source = pickLastAdClick(touches) || latestUtmTouch(touches)
  const fields = {}
  if (!source) return fields
  if (source.click_id) {
    const name = clickFieldName(source.id_type)
    if (name) fields[name] = source.click_id
  }
  copyUtms(fields, source)
  return fields
}

function sanitizeWaPath(path) {
  const safe = path || '/'
  if (safe.charAt(0) !== '/' || safe.indexOf('//') === 0 || safe.length > 120) return '/'
  return safe
}

function visitTimeForParams(touches, params) {
  const keys = ['gclid', 'gbraid', 'wbraid', 'ttclid', 'ScCid', 'msclkid']
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const value = params.get(key)
    if (!value) continue
    const idType = key === 'ScCid' ? 'sccid' : key
    for (let n = 0; n < touches.length; n++) {
      const touch = touches[n]
      if (touch && touch.id_type === idType && touch.click_id === value && touch.ts) return touch.ts
    }
  }
  return ''
}

function buildWaSearchParams(input) {
  input = input || {}
  const params = new URLSearchParams()
  params.set('src', input.src || 'site')
  params.set('p', sanitizeWaPath(input.path))

  const current = new URLSearchParams(input.search || '')
  let hasAd = false
  CLICK_ID_KEYS.forEach(function (key) {
    let value = current.get(key) || ''
    if (key === 'ScCid' && !value) value = current.get('sccid') || ''
    if (!value) return
    params.set(key, value)
    hasAd = true
  })
  current.forEach(function (value, key) {
    if (key.indexOf('utm_') !== 0 || !value) return
    params.set(key, value.length > 150 ? value.slice(0, 150) : value)
    hasAd = true
  })

  const touches = Array.isArray(input.touches) ? input.touches : []
  const fbc = input.fbc || ''
  if (hasAd) {
    if (params.get('fbclid') && fbc) params.set('fbc', fbc)
    const ts = visitTimeForParams(touches, params)
    if (ts) params.set('ts', ts)
    return params
  }

  const winner = pickLastAdClick(touches)
  if (!winner) return params
  const key = clickFieldName(winner.id_type)
  if (key && winner.click_id) params.set(key, winner.click_id)
  if (winner.ts) params.set('ts', winner.ts)
  if (winner.ts_kind) params.set('ts_kind', winner.ts_kind)
  Object.keys(winner).forEach(function (name) {
    if (name.indexOf('utm_') !== 0 || !winner[name]) return
    params.set(name, String(winner[name]))
  })
  if (key === 'fbclid' && fbc) params.set('fbc', fbc)
  return params
}

module.exports = {
  TOUCHES_LS_KEY,
  UTM_KEYS,
  CLICK_ID_KEYS,
  buildTouches,
  collectFormTouches,
  pickLastAdClick,
  leadSourceFields,
  matchingFbc,
  buildWaSearchParams,
}
